import { FC } from 'react'
import classNames from 'classnames'
import { FlexRow } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'
import { slugs } from '@/constants/slugs'
import { InfiniteScrollCarousel } from '@/molecules/InfiniteScrollCarousel/InfiniteScrollCarousel'
import { useTranslate } from '@/utils/translate/translate-client'
import { GEyebrowLG } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import { useGiveawayContext } from '@/views/PreSales/PreSalesGiveawayView/context/GiveawayContext'
import { PartnerLogo } from '@/views/PreSales/PreSalesGiveawayView/hooks/useGiveawayConfigData'

interface Props {
  partnerLogos: PartnerLogo[]
}

export const PartnerLogosSection: FC<Props> = ({ partnerLogos }) => {
  const { t } = useTranslate('tickets')

  const { isActive, theatricalSlug } = useGiveawayContext()

  if (!partnerLogos.length) return <div className={classNames(isActive ? 'h-[60px]' : '')}></div>

  if (partnerLogos.length === 1) {
    const partnerImage = partnerLogos[0]
    const isSoloMio = theatricalSlug === slugs.soloMio

    if (!partnerImage) return null

    return (
      <div className="grid gap-4 pb-[96px] pt-[4.5em] md:pt-[120px]">
        <GEyebrowLG className="block text-center" color="giveaway-text-subtle-light">
          {isSoloMio
            ? t('sponsoredByOurFriendsAt', 'Sponsored by our friends at:')
            : t('premiumPartners', 'INCLUDING PRODUCTS FROM OUR PREMIUM PARTNERS')}
        </GEyebrowLG>
        <FlexRow className="justify-center">
          <div>
            <Image
              src={partnerImage.src}
              alt={partnerImage.alt}
              width={isSoloMio ? 311 : 140}
              height={isSoloMio ? 48 : 140}
            />
          </div>
        </FlexRow>
      </div>
    )
  }

  return (
    <div className="grid gap-4 py-8 pb-[96px] md:pt-[60px]">
      <GEyebrowLG className="block text-center" color="giveaway-text-subtle-light">
        {t('premiumPartners', 'INCLUDING PRODUCTS FROM OUR PREMIUM PARTNERS')}
      </GEyebrowLG>
      <InfiniteScrollCarousel images={partnerLogos} />
    </div>
  )
}
